

import * as yup from "yup";

export const Inputs = [
    {
        name: "name",
        type: "text",
        icon: 'fas fa-user fa-2x',
        placeholder: { ar: 'اسم المستخدم', en: "Username" },
        col: "12",
    },
    {
        name: "phone",
        type: "text",
        inputType:"number",
        limit:11,
        icon: 'fas fa-mobile-alt fa-2xfar fa-envelope fa-2x',
        placeholder: { ar: ' رقم الموبايل', en: "Phone Number" },
        col: "12",
    },
    {
        name: "email",
        type: "text",
        icon: 'far fa-envelope fa-2x',
        placeholder: { ar: 'البريد الالكتروني', en: "Email" },
        col: "12",
    },
    {
        name: "notes",
        type: "textarea",
        icon: '',
        placeholder: { ar: 'ملاحظات', en: "Notes" },
        col: "12",
        textAreaStyle: { width: '96%', margin: '0 auto', background: ' rgb(247, 245, 245)', border: 'none', borderRadius: '15px', height: '129px', padding: '20px 29px' }
    },

]


export const config = {
    url: '/contactUs',
    redirect: false,
    signUpFlag: false,
    Sendbtn: { ar: 'اضافة', en: 'Add' },
    submitLabels: ['name', 'email', 'notes', 'phone'],
    fromcontactus:true
}
export const Validation = yup.object().shape({
    name: yup.string().required({ar:"يجب ادخال الاسم  *",en:"Name is required *"}),
    // email: yup.string().email({ar:"  البريد الالكتروني غير صحيح *",en:"Invalid Email*"}).required({ar:"يجب ادخال البريد الالكتروني *",en:"Email is required *"}),
    phone: yup.string().required({ar:'يجب ادخال  رقم الموبايل *',en:'Phone number is not valid *'}).typeError({ar:'يجب رقم الموبايل *',en:'Phone number is not valid *'}),
    notes: yup.string().required({ar:"يجب ادخال الملاحظات  *",en:"Notes is required *"}),

    // name: yup.string().required('Name is required *'),
    // phone: yup.string().required("Phone is required *"),
    // email: yup.string().required('Email is required *'),
    // notes: yup.string().required("Notes is required *"),
})